module.exports = __webpack_public_path__ + "static/media/runningman.ccff2700.jpg";